function normalizeText(value: string) {
  return value.trim();
}

function dedupeNormalizedValues(values: string[]) {
  const nextValues: string[] = [];
  const seen = new Set<string>();

  values.forEach((value) => {
    const normalizedValue = normalizeText(value);
    if (!normalizedValue) return;

    const dedupeKey = normalizedValue.toLowerCase();
    if (seen.has(dedupeKey)) return;

    seen.add(dedupeKey);
    nextValues.push(normalizedValue);
  });

  return nextValues;
}

export function splitKeywords(value: string) {
  return value
    .split(/[,\n]/)
    .map((item) => normalizeText(item))
    .filter(Boolean);
}

export function splitTrackingTerms(values: string[]) {
  const keywords: string[] = [];
  const hashtags: string[] = [];
  const mentions: string[] = [];

  dedupeNormalizedValues(values).forEach((value) => {
    if (value.startsWith('#')) {
      const normalizedHashtag = value.replace(/^#+/, '');
      if (normalizedHashtag) {
        hashtags.push(normalizedHashtag);
      }
      return;
    }

    if (value.startsWith('@')) {
      const normalizedMention = value.replace(/^@+/, '');
      if (normalizedMention) {
        mentions.push(normalizedMention);
      }
      return;
    }

    keywords.push(value);
  });

  return {
    keywords,
    hashtags,
    mentions,
  };
}

export function mergeTrackingTerms(args: {
  keywords: string[];
  hashtags: string[];
  mentions: string[];
}) {
  return [
    ...dedupeNormalizedValues(args.keywords),
    ...dedupeNormalizedValues(args.hashtags).map((value) => `#${value.replace(/^#+/, '')}`),
    ...dedupeNormalizedValues(args.mentions).map((value) => `@${value.replace(/^@+/, '')}`),
  ];
}
